import type {GridColumnVisibilityModel} from '@mui/x-data-grid-pro';
import type {ColumnConfig} from '../types';

export const mapToVisibilityModel = (
  columns: ColumnConfig[],
): GridColumnVisibilityModel => {
  const visibilityModel: GridColumnVisibilityModel = {};
  columns.forEach(c => {
    visibilityModel[c.name] = c.visible || false;
  });

  return visibilityModel;
};
